package com.milta.core.localization.translations.ro

import com.milta.core.localization.WebImportRouteStrings

internal val WebImportRoute = WebImportRouteStrings(
    headerSubtitle = "Încărcați un fișier de livrări și atribuiți-l unui șofer",
    stepImport = "Import",
    stepVerifyAssign = "Verifică și atribuie",
    stepValidateSend = "Validează și trimite traseele",
    dropzoneTitle = "Trageți și plasați fișierul dvs. de livrări",
    dropzoneOrPrefix = "sau",
    browseFilesLink = "răsfoiți fișierele",
    browseFilesButton = "Răsfoiește fișierele",
    constraintsLabel = "Excel (.xlsx, .xls), CSV sau PDF · max. 500 opriri · 10 MB",
    expectedColumnsEyebrow = "Coloane așteptate în fișier",
    columnRecipientName = "Numele destinatarului",
    columnAddress = "Adresă completă",
    columnDeadline = "Oră limită",
    columnPhone = "Telefon",
    requiredPillLabel = "Obligatoriu",
    optionalPillLabel = "Opțional",
    analysingLabel = "Se analizează…",
    analysingCanLeaveLabel = "Fișier trimis. Puteți părăsi această pagină, analiza continuă.",
    importOnMobileMessage = "Un import este în curs în aplicația mobilă (%s). Finalizați-l în aplicație pentru a importa aici un alt fișier.",
    invalidFileTitle = "Fișier ilizibil sau format neacceptat",
    invalidFileMessage = "„%s” nu a putut fi analizat. Utilizați un fișier Excel (.xlsx, .xls), CSV sau PDF care respectă coloanele așteptate.",
    chooseAnotherFileButton = "Alegeți alt fișier",
    extractionFailedTitle = "Livrările nu pot fi extrase",
    extractionFailedMessage = "Fișierul „%s” a fost citit, dar nu s-a găsit nicio linie utilizabilă. Verificați dacă acesta conține coloanele așteptate.",
    serviceUnavailableTitle = "Serviciul de analiză este temporar indisponibil",
    serviceUnavailableMessage = "Nu putem analiza fișierul dvs. momentan. Fișierul dvs. este păstrat: încercați din nou peste câteva momente.",
    retryButton = "Reîncearcă",
    fileImportedStatus = "Fișier importat",
    stopsDetectedSuffix = "opriri detectate",
    replaceFileLink = "↺ Înlocuiește",
    assignToEyebrow = "Atribuie către",
    selectDriverRequiredError = "Selectați cel puțin un șofer înainte de a trimite traseul.",
    selectedDriversCountSuffix = "șoferi selectați",
    optimizeRouteButton = "Optimizează traseul",
    tableCaptionLead = "Verificați și corectați opririle înainte de a trimite",
    tableCaptionHint = "Faceți clic pe creion pentru a corecta o linie",
    locationBlockedHint = "Fiecare rând trebuie să aibă o adresă localizată (GPS) înainte de trimiterea către șoferi. Corectează rândurile afectate (✎) sau reîncearcă geocodarea.",
    columnHeaderIndex = "#",
    columnHeaderRecipientName = "Nume destinatar",
    columnHeaderAddress = "Adresă",
    columnHeaderPhone = "Telefon",
    columnHeaderDeadline = "Oră limită",
    columnHeaderPackageCount = "Colete",
    dashPlaceholder = "—",
    discardDraftButton = "Anulează importul",
    discardDraftDialogTitle = "Anulezi acest import?",
    discardDraftDialogMessage = "Livrările deja importate vor fi pierdute definitiv. Această acțiune nu poate fi anulată.",
    discardDraftConfirmButton = "Da, anulează importul",
    freeFormatBanner = "Format liber detectat — coloanele nu au putut fi recunoscute automat, verificați fiecare linie înainte de a trimite.",
    incompleteStopsBannerSuffix = "opriri incomplete — lipsește numele sau adresa, de corectat înainte de trimitere.",
    rowFlagMissingName = "⚠ nume lipsă",
    rowFlagMissingAddress = "⚠ adresă lipsă",
    alreadyDispatchedBanner = "Acest traseu a fost deja trimis unui șofer — reîmprospătați pagina pentru a reporni cu un import nou.",
    routeNotFoundError = "Traseu negăsit. Reîmprospătați pagina și încercați din nou.",
    validationErrorGeneric = "Verificați informațiile introduse.",
    submitServerError = "A apărut o eroare. Încercați din nou.",
    submitOptimizationUnavailableError = "Serviciul de optimizare este temporar indisponibil. Traseul nu a fost creat — încercați din nou peste câteva momente.",
    sendWithoutOptimizationButton = "Trimite fără optimizare",
    dispatchSuccessMessage = "Traseul a fost trimis cu succes către %s",
    dispatchSuccessBatchMessage = "Traseele au fost trimise cu succes către %d șoferi",
    tooManyStopsError = "Acest fișier conține mai mult de 500 de livrări. Vă rugăm să îl împărțiți înainte de a-l importa.",
    resultHeaderMiddle = "livrări repartizate între",
    resultDriverSingularSuffix = "șofer",
    resultDriverPluralSuffix = "șoferi",
    resultDistanceLabel = "Distanță",
    resultDurationLabel = "Durată estimată",
    resultMetricNotCalculatedLabel = "Necalculată",
    resultStopsChipSuffix = "opriri",
    resultMoreStopsTemplate = "+ %d alte opriri",
    resultStopsLoadError = "Opririle acestui traseu nu au putut fi încărcate.",
    resultDispatchButton = "Validează și trimite traseele",
)
